import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMessages, sendMessage, receiveMessages, receiveSignals, getProfileData, wipeChatData } from 'actions/chat';
import { updateUser, giveFreeQuestion } from 'actions/superuser';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import Socket from './ws';
import { Message, Recipient } from 'elements';
import { Input, Button } from 'antd';
import uuidv4 from 'uuid/v4';
import { showMaropostForNonSuperUser, showRecipientEmailForNonSuperUser } from 'configuration';
import CN from 'classnames';
import countyCodes from 'utils/countryCodes';

import './ChatPage.css';
import { ADMIN_ROLES } from 'layouts/partials/header/Header';
import { addStatementToBot } from 'utils/psychic_bot_apis';

const { TextArea } = Input;


function mapState(state) {
  return {
    ...state.chat,
    accessToken: state.auth.accessToken,
    senderUUID: state.auth.user.uuid,
    admin: state.auth.admin,
    suAccessToken: state.auth.suAccessToken
  };
}

function mapDispatch(dispatch, props) {
  return {
    getMessages(conversationUUID, pagination, filters) {
      return getMessages(dispatch, props.history, conversationUUID, pagination, filters);
    },
    sendMessage(conversationUUID, data) {
      return sendMessage(dispatch, props.history, conversationUUID, data);
    },
    receiveMessages(conversationUUID, data) {
      return receiveMessages(dispatch, props.history, conversationUUID, data);
    },
    receiveSignals(conversationUUID, data) {
      return receiveSignals(dispatch, props.history, conversationUUID, data);
    },
    getProfileData(uuid, email) {
      return getProfileData(dispatch, props.history, uuid, email);
    },
    wipeChatData() {
      return wipeChatData(dispatch, props.history);
    },
    updateUser(data) {
      return updateUser(dispatch, data);
    },
    giveFreeQuestion(data) {
      return giveFreeQuestion(dispatch, data);
    }
  };
}

class ChatPage extends Component {

  static propTypes = {
    pagination: React.PropTypes.object,
    participantProfileData: React.PropTypes.object,
    messages: React.PropTypes.array,
    participants: React.PropTypes.array,
    history: React.PropTypes.object,
    accessToken: React.PropTypes.string,
    senderUUID: React.PropTypes.string,
    suAccessToken: React.PropTypes.string,
    participant: React.PropTypes.string,
    getMessages: React.PropTypes.func,
    sendMessage: React.PropTypes.func,
    updateUser: React.PropTypes.func,
    receiveMessages: React.PropTypes.func,
    giveFreeQuestion: React.PropTypes.func,
    getProfileData: React.PropTypes.func,
    receiveSignals: React.PropTypes.func,
    wipeChatData: React.PropTypes.func
  };

  state = {
    messageText: '',
    suggestionText: null,
    questionText: null,
    buttonActive: true
  };


  componentWillMount() {
    const conversationUUID = this.props.match.params.uuid;
    const _receiveMessages = this.props.receiveMessages;
    const _receiveSignals = this.props.receiveSignals;

    console.log('Chat mounted!');
    console.log(conversationUUID);

    this.socket = Socket(this.props.accessToken);
    this.props.getMessages(conversationUUID, this.props.pagination);

    this.socket.emit('join', { conversation: conversationUUID });
    this.socket.on('error', function (data) {
      console.error(data);
    });

    this.socket.on('receiveMessages', function (data) {
      console.log(data);
      _receiveMessages(conversationUUID, data);
    });

    this.socket.on('receiveSuggestions', function (data) {
      console.log(data);
      _receiveMessages(conversationUUID, data);
    });

    this.socket.on('receiveSignals', function (data) {
      console.log(data);
      _receiveSignals(data, conversationUUID);
    });
  }

  componentWillUnmount() {
    const conversationUUID = this.props.match.params.uuid;
    this.socket.emit('leave', { conversation: conversationUUID });
    this.socket.emit('disconnect');
    this.props.wipeChatData();
    console.log('Chat unmounted!');
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  loadParticipantData() {
    const participant = _.find(this.props.participants, i => i.uuid !== this.props.senderUUID);
    participant ? this.props.getProfileData(participant.uuid, participant.email) : null;
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  sendMessage(text, suggestionUsed = false) {
    const conversationUUID = this.props.match.params.uuid;
    const { uuid } = _.find(this.props.participants, i => i.uuid !== this.props.senderUUID);
    const { admin } = this.props;
    const message = {
      conversation: conversationUUID,
      text,
      suggestionUsed,
      receiverUUID: uuid,
      sender: this.props.senderUUID,
      admin: admin ? admin.uuid : null,
      clientId: uuidv4(),
      justSent: true
    };

    console.log(message);
    this.socket.emit('sendMessage', message);
    this.props.sendMessage(conversationUUID, message);
  }

  giveFreeQuestion() {
    this.setState({ buttonActive: false });
    const data = {
      userUUID: _.find(this.props.participants, i => i.uuid !== this.props.senderUUID).uuid,
      conversationUUID: this.props.match.params.uuid,
      psychicUUID: this.props.senderUUID
    };

    this.props.giveFreeQuestion(data)
      .then(() => {
        return this.loadParticipantData();
      })
      .then(() => {
        console.log('added free q successfully');
      })
      .catch(e => {
        console.error(`error giving free question: ${ e }`);
      });
  }

  displayMaropost() {
    if (this.props.suAccessToken) {
      return true;
    } else {
      return showMaropostForNonSuperUser;
    }
  }

  displayEmail() {
    if (this.props.suAccessToken && this.props.admin.role === ADMIN_ROLES.SUPERUSER) {
      return true;
    } else {
      return showRecipientEmailForNonSuperUser;
    }
  }

  handleMessageSend() {
    const { messageText, questionText, suggestionText } = this.state;
    if (!messageText) {
      alert('message is empty!');
    } else {
      this.sendMessage(messageText, !!suggestionText);
      this.setState({ messageText: '', suggestionText: null });
      if (questionText) {
        if (suggestionText !== messageText) {
          addStatementToBot(questionText, messageText);
        }
        this.setState({ questionText: null });
      }
    }
  }

  onChangeHandler(e) {
    this.setState({ messageText: e.target.value });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      if (e.nativeEvent.shiftKey) {
        console.log('shift+enter pressed!');
      } else {
        e.preventDefault();
        this.handleMessageSend();
        console.log('enter pressed!');
      }
    }
  }

  scrollToBottom = () => {
    setTimeout(() => {
      const objDiv = document.getElementById('messageList');
      objDiv.scrollTop = objDiv.scrollHeight;
    }, 500);

  };

  handleLoadMore(page) {
    const conversationUUID = this.props.match.params.uuid;
    const _pagination = this.props.pagination;
    _pagination.current = page;
    this.props.getMessages(conversationUUID, _pagination);
  }

  hasMore() {
    const { total, current, pageSize } = this.props.pagination;
    return total > ((current + 1) * pageSize);
  }

  useSuggestion(messageText, questionText = null) {
    console.table({ messageText, questionText });
    this.setState({ messageText, questionText, suggestionText: messageText });
  }

  renderParticipantData() {
    const participantProfileData = this.props.participantProfileData;
    if (!participantProfileData || !participantProfileData.user || !participantProfileData.profile) return null;
    const freeQuestionsCnt = participantProfileData.user.freeMessages;

    const cIOS = participantProfileData.profile.countryISO;

    const { importantPerson, relationshipStatus, greatestWish } = participantProfileData.profile;
    let birthStateCity, birthCity, birthCountry, birthState;
    if (cIOS) { //tarotFox env
      birthCity = participantProfileData.profile.birthCity;
      try {
        birthCountry = cIOS.startsWith('US') ? 'United States' : (_.find(countyCodes, i => i.value === cIOS)).name;
      } catch (e) {
        birthCountry = cIOS;
      }
      try {
        birthState = cIOS.startsWith('US') ? (_.find(countyCodes, i => i.value === cIOS)).name : null;
      } catch (e) {
        birthState = participantProfileData.profile.birthState || null;
      }
    } else {
      birthCountry = participantProfileData.profile.birthCountry;
      birthState = participantProfileData.profile.birthState;
      birthStateCity = participantProfileData.profile.birthStateCity;
    }

    const baseInfo = <div
      className={ CN({ 'birth-profile': freeQuestionsCnt }, { 'birth-profile-with-btn': !freeQuestionsCnt }) }>
      <div className="bold-text">Birth Profile:</div>
      <hr />
      <div><span className="bold-text">name: </span>
        <a
          className="custom-hyperlink"
          href={ `https://www.facebook.com/public/${ participantProfileData.user.name }` }
          target="_blank">
          { participantProfileData.user.name }
        </a>
      </div>
      { this.displayEmail() &&
      <div><span className="bold-text">email: </span>
        <a
          className="custom-hyperlink"
          href={ `https://www.google.com/search?q=${ participantProfileData.user.email }` }
          target="_blank">
          { participantProfileData.user.email }
        </a>
      </div>
      }
      <div><span className="bold-text">gender: </span>{ participantProfileData.profile.gender }</div>
      <div><span className="bold-text">birth date: </span>{ participantProfileData.profile.birthDate }</div>
      <div><span className="bold-text">birth time: </span>{ participantProfileData.profile.birthTime }</div>
      <div><span className="bold-text">birth country: </span>{ birthCountry }</div>
      { birthStateCity && <div><span className="bold-text">birth state/city: </span>{ birthStateCity }</div> }
      { birthState && <div><span className="bold-text">birth state: </span>{ birthState }</div> }
      { birthCity && <div><span className="bold-text">birth city: </span>{ birthCity }</div> }
      { importantPerson && <div><span className="bold-text">important person: </span>{ importantPerson }</div> }
      { relationshipStatus && <div><span className="bold-text">relationship status: </span>{ relationshipStatus }</div> }
      { greatestWish && <div><span className="bold-text">greatest wish: </span>{ greatestWish }</div> }

      <div><span className="bold-text">FREE questions count: </span>{ freeQuestionsCnt }</div>
      { !freeQuestionsCnt && <div>
        <Button
          className="free-q-btn"
          onClick={ ::this.giveFreeQuestion }
          disabled={ !this.state.buttonActive }
        >Give FREE question</Button>
      </div> }
    </div>;
    const maropostInfo = participantProfileData.maropostData ?
      <div className="maropost-data">
        <div className="bold-text">3rd Party Data:</div>
        <hr />
        <div><span className="bold-text">relationship status: </span>{ participantProfileData.maropostData.relationship_status || '-' }
        </div>
        <div><span className="bold-text">employment status: </span> { participantProfileData.maropostData.employment_status || '-' }
        </div>
        <div><span className="bold-text">greatest wish: </span>{ participantProfileData.maropostData.greatest_wish || '-' }
        </div>
        <div><span className="bold-text">question: </span>{ participantProfileData.maropostData.question || '-' }
        </div>
        <div><span className="bold-text">important: </span>{ participantProfileData.maropostData.important || '-' }
        </div>
        <div><span className="bold-text">inquiry: </span>{ participantProfileData.maropostData.inquiry || '-' }
        </div>
        <div><span
          className="bold-text">first heartbreak: </span>{ participantProfileData.maropostData.first_heartbreak || '-' }
        </div>
        <div><span className="bold-text">positive energy: </span>{ participantProfileData.maropostData.positive_energy || '-' }</div>
        <div><span className="bold-text">biggest regret: </span>{ participantProfileData.maropostData.biggest_regret || '-' }</div>
        <div><span className="bold-text">accomplish: </span>{ participantProfileData.maropostData.accomplish || '-' }</div>
        <div><span className="bold-text">reconnect name: </span>{ participantProfileData.maropostData.reconnect_name || '-' }</div>
        <div><span className="bold-text">needs in life: </span>{ participantProfileData.maropostData.needs_in_life || '-' }</div>

        <div><span className="bold-text">Name mentioned in App 1: </span>{ participantProfileData.maropostData.p_app_name1 || '-' }</div>
        <div><span className="bold-text">Name mentioned in App 2: </span>{ participantProfileData.maropostData.p_app_name2 || '-' }</div>
        <div><span className="bold-text">Name mentioned in App 3: </span>{ participantProfileData.maropostData.p_app_name3 || '-' }</div>
        <div><span className="bold-text">Name mentioned in App 4: </span>{ participantProfileData.maropostData.p_app_name4 || '-' }</div>
        <div><span className="bold-text">Name mentioned in App 5: </span>{ participantProfileData.maropostData.p_app_name5 || '-' }</div>
        <div><span className="bold-text">Name mentioned in App 6: </span>{ participantProfileData.maropostData.p_app_name6 || '-' }</div>
        <div><span className="bold-text">Name mentioned in App 7: </span>{ participantProfileData.maropostData.p_app_name7 || '-' }</div>

        <div><span className="bold-text">social psychic question: </span>{ participantProfileData.maropostData.social_psychic_question || '-' }</div>
        <div><span className="bold-text">purchased something: </span>{ participantProfileData.maropostData.purchased_something || '-' }</div>

        <div><span className="bold-text">Persons Middle Initial: </span>{ participantProfileData.maropostData.claritas_persons_middle_initial || '-' }</div>
        <div><span className="bold-text">First related name to person: </span>{ participantProfileData.maropostData.claritas_related_name_1 || '-' }</div>
        <div><span className="bold-text">Second related name to person: </span>{ participantProfileData.maropostData.claritas_related_name_2 || '-' }</div>
        <div><span className="bold-text">Third related name to person: </span>{ participantProfileData.maropostData.claritas_related_name_3 || '-' }</div>
        <div><span className="bold-text">City person is in: </span>{ participantProfileData.maropostData.claritas_city || '-' }</div>
        <div><span className="bold-text">State person is in: </span>{ participantProfileData.maropostData.claritas_childs_birth_year || '-' }</div>
        <div><span className="bold-text">Year child was born: </span>{ participantProfileData.maropostData.claritas_childs_birth_month || '-' }</div>
        <div><span className="bold-text">Month child was born: </span>{ participantProfileData.maropostData.claritas_rough_childs_age || '-' }</div>
        <div><span className="bold-text">Age of Child: </span>{ participantProfileData.maropostData.claritasstate || '-' }</div>
      </div> :
      <div className="maropost-data">
        <div className="bold-text">3rd Party Data:</div>
        <hr />
        <div className="maropost-warning">No data found</div>
      </div>;
    return (<div>
      { baseInfo }
      { this.displayMaropost() && maropostInfo }
    </div>);
  }

  render() {
    const ownUUID = this.props.senderUUID;
    const messages = this.props ? (this.props.messages ? this.props.messages : []) : [];
    const reversedMessages = [];
    const participantProfileData = this.props.participantProfileData;
    const receiver = _.find(this.props.participants, i => i.uuid !== this.props.senderUUID);
    const showSecretData = this.displayEmail();

    _.forEachRight(messages, n => {
      n.ownMessage = (n.sender === ownUUID);
      reversedMessages.push(n);
    });

    return (
      <div className="p-20">
        <div className="recipient-info">
          { this.renderParticipantData() }
        </div>
        <div className="message-list" id="messageList">
          {
            _.map(reversedMessages, (n, i) => <Message key={ i } message={ n } showSecretData={ showSecretData } useSuggestion={ (s, a) => this.useSuggestion(s, a) } />)
          }
        </div>
        { receiver ? <Recipient
          data={ receiver }
          profile={ participantProfileData }
          displayEmail={ this.displayEmail() }
          loadProfile={ ::this.loadParticipantData }
        /> : '' }
        <TextArea
          value={ this.state.messageText }
          autosize={ { minRows: 3, maxRows: 3 } }
          onKeyPress={ ::this.handleKeyPress }
          onChange={ ::this.onChangeHandler }
        />
        <Button
          className="send-btn"
          onClick={ ::this.handleMessageSend }
        >Send</Button>
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(ChatPage));



// WEBPACK FOOTER //
// ./src/pages/chat/ChatPage.jsx